// Stripe reports currency as a lowercase ISO 4217 code (`usd`); TikTok,
// Meta, Reddit and Google Ads all expect it uppercase. USD is the
// fallback only when the API returns nothing — never a substitute for a
// currency it did report.
//
// The shape check is load-bearing beyond tidiness: the result is
// interpolated into a JS string literal inside an inline pixel script,
// so rejecting anything that isn't three plain letters is what keeps
// that script well-formed.
export function normalizeCurrency(currency: string | null | undefined): string {
  const upper = (currency ?? '').trim().toUpperCase();
  return /^[A-Z]{3}$/.test(upper) ? upper : 'USD';
}
